/**
 * Ayudante "+ IVA %" de captura de compras: convierte un precio impreso SIN impuestos
 * (tickets de POS chicos que desglosan IMPUESTO global) al precio final realmente pagado.
 *
 * Nota de redondeo: el ticket mismo imprime el precio sin IVA ya redondeado a centavos, así que al
 * reconstruir puede quedar 1 centavo de diferencia por línea (p. ej. anaquel $36.00 → ticket $31.03
 * → $31.03 × 1.16 = $35.99). El verificador es el total del pie contra el TOTAL del ticket.
 */
export function applyTaxToAmount(amount: number, ratePercent: number): string {
  return (amount * (1 + ratePercent / 100)).toFixed(2);
}

/** Valida el % que teclea el empleado en "cambiar %": número > 0 y ≤ 100. */
export function parseTaxRatePercent(raw: string): number | null {
  const value = Number(raw);
  return Number.isFinite(value) && value > 0 && value <= 100 ? value : null;
}
